(() => {
  function init(scope) {
    scope.querySelectorAll('[data-gd-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      function select(index, focus) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i, false));
        tab.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight') index = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { event.preventDefault(); select(index, true); }
        });
      });
    });
  }
  init(document);

  // Placeholder slots are for the team: show them in draft previews, never on the live theme.
  const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  if (role && role !== 'main') {
    const hiddenPlaceholders = document.querySelectorAll('[data-gd-preview-only][hidden]');
    hiddenPlaceholders.forEach(el => { el.hidden = false; });
    if (hiddenPlaceholders.length) window.dispatchEvent(new Event('resize'));
  }

  // Keep the Body Science section above the page while its pop-up is open.
  document.querySelectorAll('.bs-download').forEach(popup => {
    const sectionEl = popup.closest('.shopify-section');
    if (!sectionEl) return;
    new MutationObserver(() => sectionEl.classList.toggle('gd-guide-open', popup.classList.contains('is-open')))
      .observe(popup, { attributes: true, attributeFilter: ['class'] });
  });

  // A banner button can open the Body Science guide download on the same page.
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-gd-open-guide]');
    if (!opener) return;
    const trigger = document.querySelector('.bs-hero__download-trigger');
    if (!trigger) return;
    event.preventDefault();
    // The guide opens as a full-screen layer right where the visitor is; no scrolling.
    const y = window.scrollY;
    if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    requestAnimationFrame(() => window.scrollTo(0, y));
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
